import classes from "./modal.module.css";
import { ReactComponent as Cancel } from "../../assets/svgs/cancel.svg";

const Modal = ({ children, cancel }) => {
  return (
    <div className={classes.bg}>
      <div className={classes.blue}>
        {cancel && (
          <div className={classes.btn}>
            <button>
              <Cancel />
            </button>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
